/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/bonz/joinNow/joinNow.app.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'bonz/joinNow/joinNow.app', exports: {} }; const exports = module.exports;

import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';

// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);
import joinForm from '@grins/fd-modules/bonz/joinNow/joinForm';

import perksModal from '@grins/fd-modules/bonz/shared/perksModal';

function run() {
    checkDependencies(module.name, debugLog);
    joinForm.init();
    perksModal.init();
}
run();
export default {  };